// action - state management
import * as actionTypes from './cartActions';

const initialState = {
    error: null,
    checkout: {
        step: 0,
        products: [],
        subtotal: 0,
        total: 0,
        discount: 0,
        shipping: 0,
        billing: null,
        payment: {
            type: 'zaao',
            method: 'cod',
            card: ''
        },
        delivery: {
            address: null,
            type: 'zaao'
        }
    }
};
// ==============================|| CUSTOMIZATION REDUCER ||============================== //

const cartReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.DELIVERY_TYPE:
            return {
                ...state,
                checkout: {
                    ...state.checkout,
                    delivery: {
                        type: action.payload.deliveryType,
                        address: action.payload.deliveryAddress
                    }
                }
            };
        case actionTypes.BILLING_ADDRESS:
            return {
                ...state,
                checkout: {
                    ...state.checkout,
                    billing: action.payload
                }
            };
        case actionTypes.BACK_STEP_SUCCESS:
            return {
                ...state,
                checkout: {
                    ...state.checkout,
                    step: state.checkout.step - 1
                }
            };
        case actionTypes.NEXT_STEP_SUCCESS:
            return {
                ...state,
                checkout: {
                    ...state.checkout,
                    step: state.checkout.step + 1
                }
            };
        case actionTypes.STEP_SUCCESS:
            return {
                ...state,
                checkout: {
                    ...state.checkout,
                    step: action.payload
                }
            };
        case actionTypes.CHANGE_QUANTITY:
            return {
                ...state,
                checkout: {
                    ...state.checkout,
                    products: action.payload
                }
            };
        case actionTypes.SHIPPING_CHARGE_UPDATE:
            const shippingPrice = action.payload.shipping_price;
            const subtotal = state.checkout.products.reduce((sum, product) => sum + product.quantity * product.offerPrice, 0);
            const totalPrice = subtotal + shippingPrice;
            return {
                ...state,
                checkout: {
                    ...state.checkout,
                    subtotal: subtotal,
                    total: totalPrice,
                    shipping: shippingPrice
                }
            };
        case actionTypes.UPDATE_PRODUCTS:
            let updatedCartProducts;
            updatedCartProducts = action.payload.map((product) => {
                return {
                    id: product.id,
                    offerPrice: product.price,
                    image: product.image,
                    name: product.name,
                    quantity: product.quantity,
                    images: product.images
                };
            });
            return {
                ...state,
                checkout: {
                    ...state.checkout,
                    products: updatedCartProducts
                }
            };
        case actionTypes.ADD_PRODUCT:
            const existingProductIndex = state.checkout.products.findIndex((product) => product.id === action.payload.id);

            let updatedProducts;

            if (existingProductIndex !== -1) {
                // Product exists — increment quantity
                updatedProducts = state.checkout.products.map((product, index) =>
                    index === existingProductIndex
                        ? { ...product, quantity: (product.quantity || 1) + (action.payload.quantity || 1) }
                        : product
                );
            } else {
                // Product doesn't exist — add it with quantity 1
                updatedProducts = [...state.checkout.products, { ...action.payload, quantity: action.payload.quantity || 1 }];
            }

            return {
                ...state,
                checkout: {
                    ...state.checkout,
                    products: updatedProducts
                }
            };
        default:
            return state;
    }
};

export default cartReducer;
